// Los comprobantes del pedido para el comercio (decisión D57): su factura (o nota de venta, o comprobante interno), las
// notas de crédito y la remisión, con "Ver y descargar". Solo aparece si la distribuidora da la copia en la tienda y el
// pedido ya tiene alguno.
import { Icono } from '@reparto/ui';
import { useNavigate } from 'react-router';
import { ESTADO_COMPROBANTE_ETIQUETA, formatoGs, TIPO_DOCUMENTO_FISCAL_ETIQUETA } from '../compartido';
import { comprobantesDelPedido, nombreDocumento } from '../datos/comprobantes';
import { useConsulta } from '../datos/consultas';

export function ComprobantesPedido({ pedidoId }: { pedidoId: string }) {
  const navegar = useNavigate();
  const c = useConsulta(`comprobantes:${pedidoId}`, () => comprobantesDelPedido(pedidoId));
  const datos = c.datos?.habilitado ? c.datos.datos : [];
  if (!datos.length) return null;
  return (
    <section aria-labelledby="comprobantes">
      <h2 id="comprobantes" className="mb-3 text-xl font-bold text-stone-900">
        {datos.length === 1 ? 'Tu comprobante' : 'Tus comprobantes'}
      </h2>
      <ul className="divide-y divide-stone-100 rounded-3xl border border-stone-200 bg-white shadow-sm">
        {datos.map((d) => (
          <li key={d.id}>
            <button
              type="button"
              onClick={() => navegar(`/pedidos/${pedidoId}/comprobante/${d.id}`)}
              className="flex w-full items-center gap-3 px-4 py-3 text-left"
            >
              <Icono nombre="receipt_long" className="shrink-0 text-primary-700" />
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[17px] font-medium text-stone-900">
                  {nombreDocumento(d, TIPO_DOCUMENTO_FISCAL_ETIQUETA[d.tipo])}
                </span>
                <span className="block text-[15px] text-stone-600">
                  {d.estado === 'emitido' ? 'Ver y descargar' : ESTADO_COMPROBANTE_ETIQUETA[d.estado]}
                  {d.tipo !== 'remision' ? ` · ${formatoGs(d.total)}` : ''}
                </span>
              </span>
              <Icono nombre="chevron_right" className="shrink-0 text-stone-400" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
